<template>
  <section class="pt-base pb-base">
    <div class="container items-center">
      <h3 class="section--h3 text-4xl">Important to Remember</h3>
      <p class="section--p text-base">
        Microlearning =/= Chopping Up Long Content
      </p>
      <vs-card class="w-4/5 mb-base items-left">
        <div class="alex-title p-5">
          <div class="w-1/10">
            <div class="number-bullet mr-4">1</div>
          </div>
          Collate
        </div>
        <div class="alex-content p-5 items-left">
          <p>
            There is no shortage of content in today's world on the contrary it
            is too much to sort and manage. Organizations have lots of resources
            mostly distributed within departments or tools. There is no need to
            re-invent the wheel, let’s bring all the resources and build your
            library from what is already available. Even though we recommend to
            quality check the content while adding it, ALEX also has inherent
            feedback and iterative rating mechanisms that sort the content
            continuously to promote better quality content and bury the lower
            quality ones.
          </p>
        </div>
      </vs-card>
      <vs-card class="w-4/5 mb-base items-left">
        <div class="alex-title p-5">
          <div class="w-1/10">
            <div class="number-bullet mr-4">2</div>
          </div>
          Curate Immersive Content
        </div>
        <div class="alex-content p-5 items-left">
          <p>
            ALEX manages the library by dynamically sorting content based on
            learner's feedbacks and internal ratings. ALEX itself is learning
            mechanism that learns about what to distribute and to whom and keeps
            getting better at its suggestions. In order to curate the content we
            define the modality, time, targeted development area, meta data and
            post training feedback and confirm effectiveness by conducting pilot
            training events, to refine the training experience as necessary.
          </p>
        </div>
      </vs-card>
      <vs-card class="w-4/5 mb-base items-left">
        <div class="alex-title p-5">
          <div class="w-1/10">
            <div class="number-bullet mr-4">3</div>
          </div>
          Create
        </div>
        <div class="alex-content p-5 items-left">
          <p>
            Now that we know the knowledge gaps of our people and that we have
            accordingly identified the content gaps around trainings, let's
            create the training material for the intended audience. This
            includes videos, graphics, images, audio, tutorials, quizzes, and
            other learning materials even in various participative forms. Learn
            how to create effective micro-learning content.
          </p>
        </div>
      </vs-card>
    </div>
  </section>
</template>

<script>
export default {
  name: "ImpRemember",
};
</script>

<style scoped>
section {
  background: #f7f8f9;
}

.con-vs-card >>> .vs-card--content {
  padding: 0 !important;
}

.alex-title {
  background: rgba(220, 0, 50, 0.1);
  border-radius: 12px 12px 0px 0px;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 24px;
  color: #dc0032;
  display: flex;
  align-items: center;
}

.alex-content p {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 26px;
  color: #848199;
}
.number-bullet {
  background: #dc0032;
  box-shadow: 0px 4px 12px rgba(220, 0, 50, 0.25);
  border-radius: 50%;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 42px;
  width: 42px;
}

@media (max-width: 1200px) {
}
</style>
